import { render, staticRenderFns } from "./area-others.md?vue&type=template&id=1c1f4a23&"
import script from "./area-others.md?vue&type=script&lang=js&"
export * from "./area-others.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1f4a23')) {
      api.createRecord('1c1f4a23', component.options)
    } else {
      api.reload('1c1f4a23', component.options)
    }
    module.hot.accept("./area-others.md?vue&type=template&id=1c1f4a23&", function () {
      api.rerender('1c1f4a23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Area/area-others.md"
export default component.exports